import React from 'react';
import { MapPin } from 'lucide-react';
import { LocationMap } from '../ui/LocationMap';
export function Contact() {
  return <section id="contact" className="py-24 bg-prt-darker" data-id="element-56">
      <div className="container mx-auto px-6" data-id="element-57">
        <div className="mb-16 text-center lg:text-left" data-id="element-58">
          <span className="text-prt-tan font-semibold tracking-[0.2em] text-sm uppercase mb-4 block" data-id="element-59">
            Get In Touch
          </span>
          <h2 className="font-heading text-white text-4xl md:text-5xl" data-id="element-60">
            We'd Love to Hear From You
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20" data-id="element-61">
          {/* Map */}
          <div className="flex flex-col" data-id="element-62">
            <div className="bg-prt-surface border border-white/10 rounded-lg h-[400px] relative overflow-hidden mb-6" data-id="element-63">
              <LocationMap lat={33.2628} lng={-111.7218} label="Potential Realized Training" data-id="element-64" />
            </div>

            <div className="bg-prt-surface p-6 rounded-lg border-l-4 border-prt-blue" data-id="element-65">
              <h3 className="text-white font-heading text-xl tracking-wide mb-2" data-id="element-66">
                Address
              </h3>
              <p className="text-prt-muted" data-id="element-67">
                6348 S Higley Rd
                <br data-id="element-68" />
                Gilbert, AZ 85298
              </p>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-prt-surface p-8 rounded-lg border border-white/5" data-id="element-69">
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-70">
              <div data-id="element-71">
                <label className="block text-white text-sm font-medium mb-2 uppercase tracking-wider" data-id="element-72">
                  Name
                </label>
                <input type="text" className="w-full bg-prt-darker border border-white/10 rounded px-4 py-3 text-white focus:outline-none focus:border-prt-blue transition-colors min-h-[44px]" placeholder="Your Name" data-id="element-73" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-74">
                <div data-id="element-75">
                  <label className="block text-white text-sm font-medium mb-2 uppercase tracking-wider" data-id="element-76">
                    Email
                  </label>
                  <input type="email" className="w-full bg-prt-darker border border-white/10 rounded px-4 py-3 text-white focus:outline-none focus:border-prt-blue transition-colors min-h-[44px]" placeholder="you@email.com" data-id="element-77" />
                </div>
                <div data-id="element-78">
                  <label className="block text-white text-sm font-medium mb-2 uppercase tracking-wider" data-id="element-79">
                    Phone
                  </label>
                  <input type="tel" className="w-full bg-prt-darker border border-white/10 rounded px-4 py-3 text-white focus:outline-none focus:border-prt-blue transition-colors min-h-[44px]" placeholder="(555) 000-0000" data-id="element-80" />
                </div>
              </div>

              <div data-id="element-81">
                <label className="block text-white text-sm font-medium mb-2 uppercase tracking-wider" data-id="element-82">
                  Message
                </label>
                <textarea className="w-full bg-prt-darker border border-white/10 rounded px-4 py-3 text-white focus:outline-none focus:border-prt-blue transition-colors min-h-[120px] resize-y" placeholder="How can we help you reach your goals?" data-id="element-83"></textarea>
              </div>

              <button type="submit" className="w-full bg-prt-blue hover:bg-prt-blue/90 text-white px-8 py-4 rounded font-heading tracking-wider text-xl transition-colors min-h-[48px]" data-id="element-84">
                Send Message
              </button>

              <p className="text-prt-muted/50 text-xs text-center mt-4" data-id="element-85">
                This site is protected by reCAPTCHA and the Google Privacy
                Policy and Terms of Service apply.
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>;
}